import { rest } from 'msw'
import { Currency } from 'types/types'
import mockCryptoCurrencies from '../../../__mocks__/cryptoCurrencies.json'
import mockFiatCurrencies from '../../../__mocks__/fiatCurrencies.json'

const API_URL = process.env.API_URL

export const getFiatCurrencies = rest.get<Currency[]>(
  `${API_URL}/api/currency/fiat`,
  async (req, res, ctx) => {
    return res(ctx.json(mockFiatCurrencies))
  }
)

export const getCryptoCurrencies = rest.get<Currency[]>(
  `${API_URL}/api/currency/crypto`,
  async (req, res, ctx) => {
    return res(ctx.json(mockCryptoCurrencies))
  }
)

export const getCryptoCurrenciesEmpty = rest.get<Currency[]>(
  `${API_URL}/api/currency/crypto`,
  async (req, res, ctx) => {
    return res(ctx.json([]))
  }
)

export default [getFiatCurrencies, getCryptoCurrencies]
